import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Use PKCE flow - sends ?code= instead of #access_token=
    // This works on ALL browsers including Samsung Internet
    flowType: 'pkce',
    detectSessionInUrl: true,
    persistSession: true
  }
});
